export default __webpack_public_path__ + "static/imgHomepng-95835c457bb8966b0ffc7ba212f5263a.png";